var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"close",class:_vm.classes,attrs:{"type":"button","aria-label":_vm.ariaLabel || _vm.$t('labels.close')}},[_c('i',{staticClass:"fas fa-times",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }